import { PdfTemplateElement, PdfTemplateLabel } from '../entities/form-pdf-template.entity';

export const PDF_TABLE_CONTINUATION_Y_MM = 2;
export const PDF_TABLE_SAFETY_MARGIN_MM = 1;
export const PDF_TABLE_CAPTION_HEIGHT_MM = 4;
export const PDF_TABLE_BOTTOM_INSET_MM = 2;

export interface PdfBoundTableSliceMeta {
  tableRowOffset?: number;
  tableRowLimit?: number;
  tableSliceRows?: any[];
  tableShowTotals?: boolean;
  tableIsContinuation?: boolean;
  tableContinuationLabel?: string;
  tableMinHeightMm?: number;
}

export type PdfTemplateLabelWithTableSlice = PdfTemplateLabel &
  PdfBoundTableSliceMeta;

export type PdfTemplateElementWithTableSlice = PdfTemplateElement &
  PdfBoundTableSliceMeta;

export interface PdfBoundTableData {
  fields: any[];
  rows: any[];
  hasRowTotals: boolean;
  hasColumnTotals: boolean;
  continuationLabel?: string;
  minHeightMm?: number;
  columnWidthPercents?: number[];
}

export interface PdfTablePageSlice {
  index: number;
  rows: any[];
  offset: number;
  limit: number;
  isFirst: boolean;
  isContinuation: boolean;
  isLast: boolean;
  showTotals: boolean;
  continuationLabel?: string;
  minHeightMm?: number;
}

export interface PdfBoundTablePaginationOptions {
  fields: any[];
  rows: any[];
  fontSizePt: number;
  tableWidthMm: number;
  firstPageAvailableHeightMm: number;
  continuationPageAvailableHeightMm: number;
  hasColumnTotals: boolean;
  hasRowTotals?: boolean;
  safetyMarginMm?: number;
}
